import { render, staticRenderFns } from "./ClubsModal.vue?vue&type=template&id=5d553bfc&"
import script from "./ClubsModal.vue?vue&type=script&lang=js&"
export * from "./ClubsModal.vue?vue&type=script&lang=js&"
import style0 from "./ClubsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardTitle,VDataTable,VSimpleCheckbox,VTextField})
